import * as React from 'react';
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

import isEmail from 'validator/lib/isEmail';
import isStrongPassword from 'validator/lib/isStrongPassword';

import { Swiper } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import "./../../assets/swiperCss.css";
import 'swiper/css/autoplay';

import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';

import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';

import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import { themeResponsive } from "../../../theme/responsiveTheme.js";

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";

const config = require("../../../constants/constants.js")

const responsiveTheme = responsiveFontSizes(themeResponsive);

const AdminWelcomePageComponent = ({ loginUserApiRequest, reduxDispatch, setReduxUserState }) => {
  const [validated, setValidated] = useState(false);
  const [loginUserResponseState, setLoginUserResponseState] = useState({
    success: "",
    error: "",
    loading: false,
  });

  const navigate = useNavigate();

  const [applicativo, setApplicativo] = useState("");
  const [ragioneSociale, setRagioneSociale] = useState("");
  const [email, setEmail] = useState("");
  const [telefonoCallFromSite, setTelefonoCallFromSite] = useState("");
  const [linkWhatsapp, setLinkWhatsapp] = useState("");
  const [linkFacebook, setLinkFacebook] = useState("");
  const [linkInstagram, setLinkInstagram] = useState("");
  const [linkTwitter, setLinkTwitter] = useState("");
  const [linkLinkedin, setLinkLinkedin] = useState("");
  const [urlSiteImageServer, setUrlSiteImageServer] = useState("");
  const [urlCustomerImageServer, setUrlCustomerImageServer] = useState("");
  const [isShopActive, setIsShopActive] = useState("");
  const [isIconLoginActive, setIsIconLoginActive] = useState("");

  const [adminWelcomeAssignMenuItemServiceTitle, setAdminWelcomeAssignMenuItemServiceTitle] = useState("");
  const [adminWelcomeAssignMenuItemServiceSubTitle, setAdminWelcomeAssignMenuItemServiceSubTitle] = useState("");
  const [adminWelcomeAssignMenuItemEventTitle, setAdminWelcomeAssignMenuItemEventTitle] = useState("");
  const [adminWelcomeAssignMenuItemEventSubTitle, setAdminWelcomeAssignMenuItemEventSubTitle] = useState("");
  const [adminWelcomeAssignMenuItemProductTitle, setAdminWelcomeAssignMenuItemProductTitle] = useState("");
  const [adminWelcomeAssignMenuItemProductSubTitle, setAdminWelcomeAssignMenuItemProductSubTitle] = useState("");
 

  const getConfigByProgressivoApiRequest = async (progressivoRagSoc) => {
    console.log("[getConfigByProgressivoApiRequest] leggo const con progressivo =", progressivoRagSoc);
    const url = `/api/configs/progressivo/` + progressivoRagSoc;
    const { data } = await axios.get(url);
    return data
  }

  useEffect(() => {
    getConfigByProgressivoApiRequest('0001').then((data) => {
      //console.log(`data =`, data);
      setApplicativo(data?.applicativo);
      setRagioneSociale(data?.ragioneSociale);
      setEmail(data?.email);
      setTelefonoCallFromSite("tel:" + data?.telefonoCallFromSite)
      setLinkWhatsapp("https://wa.me/" + data?.linkWhatsapp);
      setLinkFacebook(data?.linkFacebook);
      setLinkInstagram(data?.linkInstagram);
      setLinkTwitter(data?.linkTwitter);
      setLinkLinkedin(data?.linkLinkedin);
      setUrlSiteImageServer(data?.urlSiteImageServer);
      setUrlCustomerImageServer(data?.urlCustomerImageServer);
      //setIsShopActive(data?.isShopActive === "Si" ? true : false);
      //setIsIconLoginActive(data?.isIconLoginActive === "Si" ? true : false);
      setIsShopActive(data?.isShopActive);
      setIsIconLoginActive(data?.isIconLoginActive);
      setAdminWelcomeAssignMenuItemServiceTitle(data?.adminWelcomeAssignMenuItemServiceTitle)
      setAdminWelcomeAssignMenuItemServiceSubTitle(data?.adminWelcomeAssignMenuItemServiceSubTitle)
      setAdminWelcomeAssignMenuItemEventTitle(data?.adminWelcomeAssignMenuItemEventTitle)
      setAdminWelcomeAssignMenuItemEventSubTitle(data?.adminWelcomeAssignMenuItemEventSubTitle)
      setAdminWelcomeAssignMenuItemProductTitle(data?.adminWelcomeAssignMenuItemProductTitle)
      setAdminWelcomeAssignMenuItemProductSubTitle(data?.adminWelcomeAssignMenuItemProductSubTitle)
      
      //console.log(`data?.applicativo =`, data?.applicativo);
      //console.log(`data?.linkWhatsapp =`, data?.linkWhatsapp);
      //console.log(`data?.linkFacebook =`, data?.linkFacebook);
      //console.log(`data?.linkInstagram =`, data?.linkInstagram);
      //console.log(`data?.linkTwitter =`, data?.linkTwitter);
      //console.log(`ragioneSociale =`, data?.ragioneSociale);
      //console.log(`urlCustomerImageServer =`, data?.urlCustomerImageServer);
      //console.log(`isShopActive =`, data?.isShopActive);
      //console.log(`isIconLoginActive =`, data?.isIconLoginActive);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [ragioneSociale, setEmail, setUrlCustomerImageServer])

  const [page, setPage] = useState({});
  const [id, setId] = useState("");
  const [title, setTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");
  const [description, setDescription] = useState("");
  const [customizedName, setCustomizedName] = useState("");
  const [customizedStreet, setCustomizedStreet] = useState("");
  const [customizedZip, setCustomizedZip] = useState("");
  const [customizedCity, setCustomizedCity] = useState("");
  const [customizedEmail, setCustomizedEmail] = useState("");
  const [tabAttivo, setTabAttivo] = React.useState('home');
  const [pathImage1, setPathImage1] = useState("");
  const [pathImage2, setPathImage2] = useState("");
  const [pathImage3, setPathImage3] = useState("");
  const [titleImage1, setTitleImage1] = useState("");
  const [subTitleImage1, setSubTitleImage1] = useState("");
  const [titleImage2, setTitleImage2] = useState("");
  const [subTitleImage2, setSubTitleImage2] = useState("");
  const [titleImage3, setTitleImage3] = useState("");
  const [subTitleImage3, setSubTitleImage3] = useState("");

  //  const address_marginLeft = "30px";
  const address_marginLeft = "0";

  const getPageByMenuValueApiRequest = async (menuValue) => {
    console.log("[getPageByMenuValueApiRequest] leggo page con menuValue =", menuValue);
    const url = `/api/pages/menuValue/` + menuValue;
    const { data } = await axios.get(url);
    //console.log(`data =`, data);
    return data
  }

  useEffect(() => {
    getPageByMenuValueApiRequest('HOME').then((data) => {
      //console.log(`data =`, data);
      setPage(data);
      setTitle(data?.title.text);
      setSubTitle(data?.subTitle.text);
      setDescription(data?.description.text);
      setTabAttivo('home');
      setId(data?._id);
      setPathImage1(data?.images[0].path);
      setPathImage2(data?.images[1].path);
      setPathImage3(data?.images[2].path);
      setCustomizedName(page?.customizedContent.name.text);
      setCustomizedStreet(page?.customizedContent.street.text);
      setCustomizedZip(page?.customizedContent.zip.text);
      setCustomizedCity(page?.customizedContent.city.text);
      setCustomizedEmail(page?.customizedContent.email.text);
      setTitleImage1(data?.imagesTitle[0].text);
      setSubTitleImage1(data?.imagesSubTitle[0].text);
      setTitleImage2(data?.imagesTitle[1].text);
      setSubTitleImage2(data?.imagesSubTitle[1].text);
      setTitleImage3(data?.imagesTitle[2].text);
      setSubTitleImage3(data?.imagesSubTitle[2].text);

      //console.log(`id =`, id);
      //console.log(`page?.images =`, page?.images);
      //console.log(`page?.title.text =`, page?.title.text);
      //console.log(`page?.description.text =`, page?.description.text);
      //console.log(`page?.customizedContent =`, page?.customizedContent);
      //console.log(`page?.customizedContent.name.text =`, page?.customizedContent.zip.text);
      //console.log(`images =`, data?.images);
      //console.log(`images =`, data?.images[0].path);
    })
      .catch((er) => {
        console.log(er);
      });
  }, [tabAttivo, id])


  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const [loginIcon, setLoginIcon] = React.useState(false);

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>

      <ThemeProvider theme={responsiveTheme}>

        <Box sx={{ flexGrow: 1 }}>

          <AdminMenuComponent></AdminMenuComponent>

          <Grid container spacing={2}>

            <Grid
              size={{ xs: 0, md: 0 }}
            >
            </Grid>

            <Grid
              size={{ xs: 10, md: 5 }}
              padding={{ xs: 0, md: 4 }}
            >

              <Box
                sx={{
                  paddingTop: 4, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                }}
              >

                <Paper
                  sx={{
                    paddingTop: 4, paddingBottom: 3, paddingLeft: 2, paddingRight: 2,
                    background: '#cce0e6'
                  }}
                  elevation={6}
                >

                  <Stack
                    padding={1}
                    spacing={2}
                    sx={{
                      flexDirection: { xs: "column", md: "column" },
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 2
                    }}
                  >

                    <Typography
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 1, paddingRight: 0,
                        fontFamily: 'Arial',
                        fontWeight: 300,
                        fontSize: 20,
                        color: 'navy',
                      }}
                    >
                      <em>benvenuto nell'area Admin</em>
                    </Typography>

                    <Typography
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                        fontFamily: 'Arial',
                        fontWeight: 100,
                        fontSize: 14,
                        color: 'black',
                      }}
                    >
                      <em>
                        1. carica immagini con estensione &nbsp;
                          <a 
                            style={{ color: "blue"}}
                          >
                              .JPG
                          </a> 
                      </em>
                    </Typography>

                    <Typography
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                        fontFamily: 'Arial',
                        fontWeight: 100,
                        fontSize: 14,
                        color: 'black',
                      }}
                    >
                      <em>
                        2. con il menu &nbsp;
                          <a 
                            style={{ color: "blue"}}
                          >
                              TIPO SERVIZIO...CONFIGURA
                          </a> 
                          &nbsp; personalizzi il SitoWeb
                      </em>
                    </Typography>

                    <Typography
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 4, paddingRight: 0,
                        fontFamily: 'Arial',
                        fontWeight: 100,
                        fontSize: 14,
                        color: 'black',
                      }}
                    >
                      per &nbsp;
                          <a 
                            style={{ color: "green"}}
                          >
                              {ragioneSociale} 
                          </a>                       
                          <a 
                            style={{ color: "black"}}
                          >
                              &nbsp; abbiamo :
                          </a>                       
                    </Typography>

                    <Box
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 7, paddingRight: 0,
                      }}
                    >
                    <Typography
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        fontFamily: 'Arial',
                        fontWeight: 100,
                        fontSize: 12,
                        color: 'black',
                      }}
                    >
                      <li>
                        {adminWelcomeAssignMenuItemServiceTitle} <br/> {adminWelcomeAssignMenuItemServiceSubTitle}
                      </li>
                    </Typography>
                    <Typography
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        fontFamily: 'Arial',
                        fontWeight: 100,
                        fontSize: 12,
                        color: 'black',
                      }}
                    >
                      <li>
                        {adminWelcomeAssignMenuItemEventTitle} <br/> {adminWelcomeAssignMenuItemEventSubTitle}
                      </li>
                    </Typography>
                    <Typography
                      sx={{
                        paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                        fontFamily: 'Arial',
                        fontWeight: 100,
                        fontSize: 12,
                        color: 'black',
                      }}
                    >
                      <li>
                        {adminWelcomeAssignMenuItemProductTitle} <br/> {adminWelcomeAssignMenuItemProductSubTitle}
                      </li>
                    </Typography>
                    </Box>  

                  </Stack>

                  <Box
                    sx={{
                      paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                      height: 100
                    }}
                  />

                </Paper>

              </Box>

            </Grid>

            <Grid
              size={{ xs: 12, md: 6 }}
              padding={{ xs: 1, md: 1 }}
              spacing={0}
            >

              <Stack
                spacing={2}
                sx={{ flexDirection: { xs: "column", md: "column" }, paddingTop: 4, paddingLeft: 0, paddingRight: 0, }}
              >

                <Typography
                  sx={{
                    paddingTop: 2, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                    fontFamily: 'Arial',
                    fontWeight: 500,
                    fontSize: 30,
                    color: 'navy',
                  }}
                >
                </Typography>

                <Typography
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 2, paddingRight: 0,
                    fontFamily: 'Arial',
                    fontWeight: 300,
                    fontSize: 20,
                    color: 'navy',
                  }}
                >
                </Typography>

                <Typography
                  sx={{
                    paddingTop: 0, paddingBottom: 0, paddingLeft: 4, paddingRight: 0,
                    fontFamily: 'Arial',
                    fontWeight: 100,
                    fontSize: 14,
                    color: 'black',
                  }}
                >
                </Typography>

              </Stack>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 30
                }}
              />

              <Grid container
                spacing={2}
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,

                }}
              >
                <Grid size={{ xs: 1, md: 1 }}>

                </Grid>

                <Grid size={{ xs: 8, md: 8 }}>

                </Grid>
              </Grid>

              <Box
                sx={{
                  paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                  height: 400
                }}
              />

            </Grid>
          </Grid>

        </Box>

      </ThemeProvider>

    </>

  );
};

export default AdminWelcomePageComponent;
